<template>
    <hooper :key="forceRerenderKey" trimWhiteSpace :itemsToShow="itemsToShow" infiniteScroll class="w-full minHeightCard h-3/4">
        <slide v-for="review in data" :key="review.reviewerName">
            <div class="mx-3" style="margin-right: 5px">
                <ReviewCard :score="review.starCount" :reviewerName="review.reviewerName" :reviewText="review.reviewText" />
            </div>
        </slide>
        <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
</template>

<script>
import 'hooper/dist/hooper.css';
import ReviewCard from '@/js/components/ReviewCard.vue';
import * as data from '@/js/data.json';
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper';
import { ScreenSize } from '@/js/util/screensize';

export default {
    name: 'App',
    components: {
        Hooper,
        Slide,
        HooperNavigation,
        ReviewCard
    },
    data() {
        return {
            data: data.reviews,
            forceRerenderKey: 0,
            windowWidth: window.innerWidth
        };
    },
    computed: {
        itemsToShow() {
            if (this.windowWidth < ScreenSize.MOBILE) {
                return 1;
            } else if (this.windowWidth >= ScreenSize.MOBILE && this.windowWidth < ScreenSize.TABLET) {
                return 2;
            } else {
                return 3;
            }
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.forceRerenderKey = new Date().getTime();
            this.windowWidth = window.innerWidth;
        },
    },
};
</script>
